
export const MINUTES_PER_PIXEL = 2;